var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'usertype-list',
  created () {
    this.search(false)
    // 最下部スクロール検索イベント
    utils.scrollBottomSearchEvent(this.search, true, 'button.next-page-search-btn')
  },
  data () {
    return {
      usertypeName: '',
      searchCallbackFlag: false
    }
  },
  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    utils.scrollBottomSearchEventRemove() // 最下部スクロール検索イベント削除
    next()
  },
  computed: {
    usertypes () {
      return this.$store.getters.usertypeList
    },
    nextPage () {
      return this.$store.getters.usertypeListNextPage
    },
    loading () {
      return this.$store.getters.apiLoading
    }
  },
  components: {
    AppHeader
  },
  methods: {
    search: function(readMore) {
      var url = null
      if (readMore) {
        url = this.$store.getters.usertypeListNextPage
      } else {
        this.searchCallbackFlag = false
      }
      var self = this
      var callback = function () {
        self.searchCallbackFlag = true
      }
      var data = {'user_type_name': this.usertypeName}
      this.$store.dispatch('USER_TYPE_LIST_SEARCH', {url: url, data: data, callback: callback})
    },
    goUserTypeNew: function () {
      this.$router.push({ path: '/user_types/new', query: { type: this.$router.currentRoute.query.type}})
    },
    goUserTypeEdit: function(usertypeId) {
      this.$router.push({ path: '/user_types/' + usertypeId + '/edit'})
    },
    usertypeDelete: function(usertypeId) {
      if (window.confirm(this.$t('Delete Confirm'))) {
        this.$store.dispatch('USER_TYPE_DELETE',  {id: usertypeId, callback: this.onSaved})
      }
    },
    half: function () {
      this.usertypeName = utils.emHalf(this.usertypeName)
    },
    onSaved: function (result) {
      this.$router.push('/user_types')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/usertype-list.js